import axiosInstance from './axiosInstance';

const aiService = {
  generateContent: async (data) => {
    try {
      console.log('Sending to AI service:', data);
      
      const response = await axiosInstance.post('/api/ai/generate', {
        bio: data.topic || '',
        vibe: data.writingStyle,
        goals: data.goals || [],
        industry: data.industry || '',
        role: data.professionalRole || '',
        targetAudience: data.targetAudience || '',
        useAdvancedSettings: data.useAdvancedSettings || false,
        includeEmojis: data.includeEmojis || false,
        includeHashtags: data.includeHashtags || false,
        contentLength: data.contentLength || 'default'
      });

      console.log('AI service response:', response);
      return response;  // Return the whole response, not just response.data
    } catch (error) {
      console.error('AI generation error:', error);
      throw error;
    }
  },

  generateImage: async (data) => {
    try {
      const response = await axiosInstance.post('/api/ai/generate-image', {
        prompt: data.prompt,
        imageSize: data.imageSize || '1024x1024'
      });
      return response.data;
    } catch (error) {
      console.error('Image generation error:', error);
      throw error;
    }
  },

  analyzeArticle: async (url) => {
    try {
      const response = await axiosInstance.post('/api/ai/analyze-article', { url });
      return response.data;
    } catch (error) {
      console.error('Article analysis error:', error);
      throw error;
    }
  },
  
  generateCarouselContent: async (data) => {
    try {
      console.log('Sending to carousel generation service:', data);
      
      const response = await axiosInstance.post('/api/ai/generate-carousel', {
        content: data.content,
        mode: data.mode || 'topic'
      });
      
      console.log('Carousel generation response:', response);
      return response.data;
    } catch (error) {
      console.error('Carousel content generation error:', error);
      throw error;
    }
  }
};

export default aiService; 